import React, { useState, useEffect, useRef } from 'react';
import ColorSwitcher from '../ColorSwitcher/ColorSwitcher'; // Importa el componente ColorSwitcher
import LanguageSelector from './LanguageSelector'; // Importa el nuevo componente LanguageSelector

const PreferencesMenu = ({ lang, setLang }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isColorOpen, setIsColorOpen] = useState(false);
  const [isLanguageOpen, setIsLanguageOpen] = useState(false);
  const menuRef = useRef(null); // Referencia para el menú de preferencias

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsOpen(false); // Cierra el menú si el clic ocurre fuera del menú
      setIsColorOpen(false); // Cierra el selector de color
      setIsLanguageOpen(false); // Cierra el selector de idioma
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleClick = () => {
    setIsColorOpen(false); // Cierra el selector de color
    setIsLanguageOpen(false); // Cierra el selector de idioma
    setIsOpen(!isOpen); // Alterna el estado del menú de preferencias
  };

  const handleColorClick = () => {
    setIsColorOpen(!isColorOpen); // Alterna el estado del selector de color
    setIsLanguageOpen(false); // Cierra el selector de idioma
  };

  const handleLanguageClick = () => {
    setIsLanguageOpen(!isLanguageOpen); // Alterna el estado del selector de idioma
    setIsColorOpen(false); // Cierra el selector de color
  };

  return (
    <div className="preferences-menu" ref={menuRef}>
      <button
        className="preferences-menu__toggle"
        onClick={() => handleClick()} // Maneja el clic para abrir/cerrar el menú de preferencias
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="3"/>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h.09a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51h.09a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v.09a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
        </svg>
      </button>
      {isOpen && (
        <div className="preferences-menu__content">
          {/* Opción de Color */}
          <div className="preferences-menu__section">
            <button
              className="preferences-menu__option"
              onClick={handleColorClick} // Maneja el clic para abrir/cerrar el selector de color
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22c4.97 0 9-3.58 9-8 0-4.42-4.03-8-9-8S3 9.58 3 14c0 2.21 1.79 4 4 4h1a1 1 0 0 1 1 1v1a2 2 0 0 0 2 2z"/>
                <circle cx="7.5" cy="14.5" r="1.5"/>
                <circle cx="12" cy="8.5" r="1.5"/>
                <circle cx="16.5" cy="14.5" r="1.5"/>
              </svg>
              Choose a Color
            </button>
            {isColorOpen && (
              <div className="preferences-menu__subcontent">
                <ColorSwitcher isOpen={isColorOpen} /> {/* Reutilizamos el componente ColorSwitcher */}
              </div>
            )}
          </div>

          {/* Opción de Idioma */}
          <div className="preferences-menu__section">
            <button
              className="preferences-menu__option"
              onClick={handleLanguageClick} // Maneja el clic para abrir/cerrar el selector de idioma
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#222" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 8, verticalAlign: "middle" }}>
                <circle cx="12" cy="12" r="10"/>
                <path d="M2 12h20"/>
                <path d="M12 2c2.5 2.5 4 6.5 4 10s-1.5 7.5-4 10c-2.5-2.5-4-6.5-4-10s1.5-7.5 4-10z"/>
              </svg>
              Select Language
            </button>
            {isLanguageOpen && (
              <div className="preferences-menu__subcontent">
                <LanguageSelector lang={lang} setLang={setLang} /> {/* Usamos el nuevo componente LanguageSelector */}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PreferencesMenu;